import { ReactNode, useState } from 'react';
import { EmptyState } from 'app/agriculture/components/EmptyState/EmptyState';
import { ListGroup } from 'app/agriculture/infobox/common/ListGroup/ListGroup';
import { generateTaskCountString } from 'app/agriculture/routes/Tasks/TaskList/utils/generateTaskCountString/generateTaskCountString';
import { TaskCategoryList } from 'app/agriculture/routes/Tasks/TaskList/components/TaskCategoryList/TaskCategoryList';
import { Task } from 'app/agriculture/queries/tasks/types/Task';

interface TasksListGroupProps {
    title: string;
    tasks: Task[];
    icon?: ReactNode;
    startExpanded?: boolean;
}

export function TasksListGroup({ title, tasks, startExpanded, icon }: TasksListGroupProps) {
    const [showCompleted, setShowCompleted] = useState(false);
    const filteredTasks = showCompleted ? tasks : tasks.filter(({ isComplete }) => !isComplete);

    const switchProps = {
        label: 'Show completed',
        defaultChecked: showCompleted,
        onChange: () => {
            setShowCompleted(!showCompleted);
        },
    };

    if (tasks.length === 0) {
        return null;
    }

    return (
        <ListGroup
            title={title}
            subtitle={generateTaskCountString(tasks)}
            startExpanded={startExpanded}
            icon={icon}
            switchProps={tasks.some(({ isComplete }) => isComplete) ? switchProps : undefined}
        >
            {filteredTasks.length === 0 && (
                <EmptyState
                    size="small"
                    message={
                        showCompleted
                            ? 'Your search returned no results'
                            : 'There are currently no active tasks'
                    }
                />
            )}
            <TaskCategoryList tasks={filteredTasks} />
        </ListGroup>
    );
}
